import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function CargoListFilter() {
    const [filterRazao, setFilterRazao] = useState<FilterValuesProps>({
        property: 'dsCargo',
        operator: 'like',
        value: '',
    });

    const [filterCod, setFilterCod] = useState<FilterValuesProps>({
        property: 'cdCargo',
        operator: 'like',
        value: null,
    });

    return (
        <Filter
            filters={[
                { value: filterCod, setter: setFilterCod },
                { value: filterRazao, setter: setFilterRazao },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Descrição do Cargo"
                    value={filterRazao.value}
                    onChange={(e) =>
                        setFilterRazao((oldState) => {
                            return { ...oldState, value: e.target.value };
                        })
                    }
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Código"
                    value={filterCod.value}
                    onChange={(e) =>
                        setFilterCod((oldState) => {
                            return { ...oldState, value: e.target.value };
                        })
                    }
                />
            </Grid>
        </Filter>
    );
}
